  (function () {
    "use strict";

    var PARAM_KEY = "ra_id";

    function getStoredRetailAdsID() {
      try {
        return window.sessionStorage.getItem(PARAM_KEY) || "";
      } catch (error) {
        return "";
      }
    }

    function storeRetailAdsIDFromURL() {
      try {
        var urlParams = new URLSearchParams(window.location.search);
        var retailAdsID = urlParams.get(PARAM_KEY);

        if (retailAdsID) {
          window.sessionStorage.setItem(PARAM_KEY, retailAdsID);
        }
      } catch (error) {}
    }

    function shouldIgnoreLink(href) {
      return !href ||
        href.indexOf("#") === 0 ||
        href.indexOf("mailto:") === 0 ||
        href.indexOf("tel:") === 0;
    }

    function isInternalURL(url) {
      return url.hostname === window.location.hostname;
    }

    function toHref(url) {
      return url.origin === window.location.origin
        ? url.pathname + url.search + url.hash
        : url.toString();
    }

    function updateLinkWithRetailAdsID(link) {
      var storedID = getStoredRetailAdsID();
      if (!storedID) return;

      var href = link.getAttribute("href");
      if (shouldIgnoreLink(href)) return;

      try {
        var url = new URL(href, window.location.origin);
        if (!isInternalURL(url)) return;

        url.searchParams.set(PARAM_KEY, storedID);
        link.setAttribute("href", toHref(url));
      } catch (error) {}
    }

    function setHiddenRetailAdsField(form, storedID) {
      var field = form.querySelector('input[type="hidden"][name="' + PARAM_KEY + '"]');

      if (!field) {
        field = document.createElement("input");
        field.type = "hidden";
        field.name = PARAM_KEY;
        form.appendChild(field);
      }

      field.value = storedID;
    }

    function updateFormWithRetailAdsID(form) {
      var storedID = getStoredRetailAdsID();
      if (!storedID) return;

      var action = form.getAttribute("action") || window.location.href;
      if (shouldIgnoreLink(action)) return;

      try {
        var url = new URL(action, window.location.origin);
        if (!isInternalURL(url)) return;

        var method = (form.getAttribute("method") || "get").toLowerCase();

        if (method === "get") {
          // Bei GET-Formularen ersetzt der Browser beim Absenden häufig den
          // Query-String der action-URL. Ein Hidden Field bleibt erhalten.
          url.searchParams.delete(PARAM_KEY);
          form.setAttribute("action", toHref(url));
          setHiddenRetailAdsField(form, storedID);
        } else {
          // POST-Formulare behalten Query-Parameter in der action-URL.
          url.searchParams.set(PARAM_KEY, storedID);
          form.setAttribute("action", toHref(url));
        }
      } catch (error) {}
    }

    function updateLinksIn(root) {
      if (!getStoredRetailAdsID()) return;

      if (root.matches && root.matches("a[href]")) {
        updateLinkWithRetailAdsID(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll("a[href]").forEach(function (link) {
          updateLinkWithRetailAdsID(link);
        });
      }
    }

    function updateFormsIn(root) {
      if (!getStoredRetailAdsID()) return;

      if (root.matches && root.matches("form")) {
        updateFormWithRetailAdsID(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll("form").forEach(function (form) {
          updateFormWithRetailAdsID(form);
        });
      }
    }

    storeRetailAdsIDFromURL();
    updateLinksIn(document);
    updateFormsIn(document);

    document.addEventListener("click", function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest("a[href]") : null;
      if (link) updateLinkWithRetailAdsID(link);
    }, true);

    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (form && form.getAttribute) updateFormWithRetailAdsID(form);
    }, true);

    // Shopify kann Links und Formulare nachträglich per Section Rendering
    // einfügen (z. B. Filter, Suche oder Cart Drawer).
    if (window.MutationObserver && document.documentElement) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            updateLinksIn(node);
            updateFormsIn(node);
          });
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();
